import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0346ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "boxed" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Using \"Authorization Code Flow with PKCE\"", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { for: "email" }
const _hoisted_7 = { class: "boxed" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Using \"Resource Owner Password Credential Flow\"", -1))
const _hoisted_9 = { for: "username" }
const _hoisted_10 = { for: "password" }
const _hoisted_11 = {
  key: 0,
  class: "loginError"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = {
  key: 4,
  class: "externalIdpTokens"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "External IdP tokens", -1))

import {
  onMounted,
  ref,
  watch,
  computed,
} from 'vue';
import { ErrorResponse, User } from 'oidc-client-ts';
import { oidcService, getExternalIdpToken, ExternalIdpToken } from '@/services/OidcService';
import UserDetails from '@/components/UserDetails.vue';
import TokensDetails from '@/components/TokensDetails.vue';
import OidcConfiguration from '@/components/OidcConfiguration.vue';
import { ConfigurationService } from '@/services/ConfigurationService';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const oidcUser = ref(null as User | null);
const oidcExternalIdpToken = ref(null as ExternalIdpToken | null);
const username = ref('aaa');
const password = ref('a');
const defaultEmail = ConfigurationService.idp.includes('HINT') ? 'a@j.com' : '';
const email = ref(defaultEmail);
const loginError = ref(null as string | null);
const ACCOUNT_PATH = 'account';
const INVALID_GRANT = 'invalid_grant';
const requestEmail = computed(() => ConfigurationService.idp.includes('HINT'));

onMounted(async () => {
  console.log('oidc-vue home Mounted');
  oidcService.addUserLoadedCallback(async (user: User) => {
    oidcUser.value = user;
    oidcExternalIdpToken.value = await getExternalIdpToken(user);
  });
  oidcService.addSilentRenewErrorCallback((error: Error) => {
    console.log(error);
    if (
      (error instanceof ErrorResponse)
      && ((error as ErrorResponse).error === INVALID_GRANT)
    ) {
      // eslint-disable-next-line
      alert(`Session expired, login again`);
      oidcUser.value = null;
      oidcExternalIdpToken.value = null;
    } else {
      // eslint-disable-next-line
      alert(`Unexpected error refreshing tokens ${error}`);
    }
  });
  oidcUser.value = await oidcService.getUser();
  oidcExternalIdpToken.value = await getExternalIdpToken(oidcUser.value);
});

async function loginAuthorizationCodeRedirect() {
  await oidcService.loginAuthorizationCodeFlowWithPkceRedirect(email.value);
}

async function loginAuthorizationCodePopup() {
  await oidcService.loginAuthorizationCodeFlowWithPkcePopup(email.value);
}

async function loginResourceOwner() {
  try {
    await oidcService.loginResourceOwnerPasswordFlow(username.value, password.value);
  } catch (e) {
    loginError.value = `${e}`;
    if (e instanceof ErrorResponse) {
      loginError.value = `${(e as ErrorResponse).message}`;
    }
    console.log(loginError.value);
  }
}

async function cleanLoginError() {
  loginError.value = null;
}

watch(username, cleanLoginError);
watch(password, cleanLoginError);

async function logout() {
  try {
    await oidcService.logout();
  } catch (e) {
    console.warn(e);
  }
  oidcUser.value = await oidcService.getUser();
}

async function account() {
  window.location.href = ConfigurationService.idp + ACCOUNT_PATH;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (oidcUser.value === null)
      ? (_openBlock(), _createBlock(OidcConfiguration, { key: 0 }))
      : _createCommentVNode("", true),
    (oidcUser.value === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_unref(requestEmail))
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _createTextVNode("email: "),
                    _withDirectives(_createElementVNode("input", {
                      id: "email",
                      type: "text",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                      size: "20"
                    }, null, 512), [
                      [_vModelText, email.value]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              type: "button",
              value: "Login (with redirect)",
              onClick: loginAuthorizationCodeRedirect
            }),
            _createElementVNode("input", {
              type: "button",
              value: "Login (with popup)",
              onClick: loginAuthorizationCodePopup
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("label", _hoisted_9, [
              _createTextVNode("Username: "),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "username",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((username).value = $event))
              }, null, 512), [
                [_vModelText, username.value]
              ])
            ]),
            _createElementVNode("label", _hoisted_10, [
              _createTextVNode("Password: "),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                id: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event))
              }, null, 512), [
                [_vModelText, password.value]
              ])
            ]),
            _createElementVNode("input", {
              type: "button",
              value: "Login",
              onClick: loginResourceOwner
            }),
            (loginError.value !== null)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(loginError.value), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("input", {
            type: "button",
            value: "Logout (Keycloak only)",
            onClick: logout
          }),
          _createElementVNode("input", {
            type: "button",
            value: "Account (Keycloak only)",
            onClick: account
          })
        ])),
    (oidcUser.value !== null)
      ? (_openBlock(), _createBlock(UserDetails, {
          key: 3,
          "oidc-user": oidcUser.value
        }, null, 8, ["oidc-user"]))
      : _createCommentVNode("", true),
    (oidcExternalIdpToken.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(TokensDetails, {
            "id-token": oidcExternalIdpToken.value.id_token,
            "access-token": oidcExternalIdpToken.value.access_token,
            "refresh-token": oidcExternalIdpToken.value.refresh_token
          }, null, 8, ["id-token", "access-token", "refresh-token"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})